// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"845ea5c12622904b","894":"015708a512153e9c"}[chunkId] + ".js";
};